import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f997c982&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AgencyBranchCard: require('/srv/rir-platform/tourism/src/tourism-front/components/common/AgencyBranchCard/index.vue').default,OnMap: require('/srv/rir-platform/tourism/src/tourism-front/components/common/OnMap/index.vue').default,Section: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Section/index.vue').default,EmptyEntity: require('/srv/rir-platform/tourism/src/tourism-front/components/common/EmptyEntity/index.vue').default})
